import React, { useContext } from 'react';

import { useAnalytics } from '../../../app/analytics';
import { MonitorContext } from '../../context/monitor-context';
import { useViewContext } from '../../context/view-context';

import { SeverityFilterContainer, StyledSlider, StyledColorSquare } from './styles';

import { Slider } from '@controlrooms/components';
import { ViewType } from '@controlrooms/models';

const SliderLevels = [
  {
    key: 'low',
    label: 'Low',
  },
  {
    key: 'medium',
    label: 'Med',
  },
  {
    key: 'high',
    label: 'High',
  },
];

interface Props {
  label?: string;
  showSlider?: boolean;
}

const SeverityFilter: React.FC<Props> = ({ label, showSlider }) => {
  const { severityFilter, setSeverityFilter } = useContext(MonitorContext);
  const { setViewState } = useViewContext();
  const { track } = useAnalytics();
  return (
    <SeverityFilterContainer>
      {label ? (
        <span className="label">{label}</span>
      ) : (
        <span className="label">
          Severity
          <br />
          Threshold
        </span>
      )}
      <div>
        <StyledSlider data-testid="styled-slider">
          {SliderLevels.map((level) => {
            return (
              <div className="level-container" key={level.key}>
                <StyledColorSquare color={level.key} />
                <span className="severity-label">{level.label}</span>
              </div>
            );
          })}
        </StyledSlider>
        {showSlider && (
          <Slider
            tooltip="Drag to adjust display threshold"
            testid="severity-treshhold"
            value={severityFilter}
            onChange={(e: number | number[]) => {
              track('Monitor - Severity Filter', {
                severityFilterIndex: severityFilter,
              });
              setSeverityFilter(e as number);
              setViewState((prev) => {
                const currentView = prev;
                currentView.view[ViewType.MONITOR].severityFilter = e as number;
                currentView.isDirty = true;
                return {
                  ...currentView,
                  isDirty: true,
                };
              });
            }}
          />
        )}
      </div>
    </SeverityFilterContainer>
  );
};

export default SeverityFilter;
